import useAuthStore from './stores/authStore';
import useAdminAuthStore from './stores/adminAuthStore';
import { getApiBaseUrl, getStaticBaseUrl } from './stores/configStore';
const API_URL = getApiBaseUrl();

export async function apiFetch(path, { method = 'GET', body, token, headers = {}, ...rest } = {}) {
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...rest,
  };
  if (body) opts.body = JSON.stringify(body);
  if (token) opts.headers['Authorization'] = `Bearer ${token}`;
  const base = getApiBaseUrl();
  const res = await fetch(`${base}${path}`, opts);
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (res.status === 401) {
    if (localStorage.getItem('adminToken')) {
      useAdminAuthStore.getState().logout();
      window.location.href = '/admin/login';
    } else {
      useAuthStore.getState().logout();
      window.location.href = '/';
    }
    throw new Error('Сессия истекла, войдите снова');
  }
  if (!res.ok) throw new Error(data.message || 'Ошибка запроса');
  return data;
}

export async function loginStudent({ login, password }) {
  return apiFetch('/students/login', {
    method: 'POST',
    body: { login, password },
  });
}

export async function loginTeacher({ login, password }) {
  return apiFetch('/teachers/login', {
    method: 'POST',
    body: { login, password },
  });
}

export async function getGroupSchedule({ groupId, week, startDate, endDate, token }) {
  let url = `/schedule/group?groupId=${groupId}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  } else if (week !== undefined) {
    url += `&week=${week}`;
  }
  return apiFetch(url, { token });
}
export async function setGroupSchedule(params) {
  const { token, ...body } = params;
  console.log('[API] setGroupSchedule отправляет:', body);
  return apiFetch('/schedule/group', {
    method: 'POST',
    body,
    token,
  });
}
export async function deleteGroupSchedule({ groupId, week, dayOfWeek, date, startTime, endTime, token }) {
  return apiFetch('/schedule/group', {
    method: 'DELETE',
    body: { groupId, week, dayOfWeek, date, startTime, endTime },
    token,
  });
}
export async function getStudentSchedule({ studentId, week, startDate, endDate, token }) {
  let url = `/schedule/student?studentId=${studentId}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  } else if (week !== undefined) {
    url += `&week=${week}`;
  }
  return apiFetch(url, { token });
}
export async function setStudentSchedule({ studentId, week, dayOfWeek, timeSlots, date, token }) {
  return apiFetch('/schedule/student', {
    method: 'POST',
    body: { studentId, week, dayOfWeek, timeSlots, date },
    token,
  });
}
export async function deleteStudentSchedule({ studentId, week, dayOfWeek, date, startTime, endTime, token }) {
  return apiFetch('/schedule/student', {
    method: 'DELETE',
    body: { studentId, week, dayOfWeek, date, startTime, endTime },
    token,
  });
}
export async function getActualStudentSchedule({ studentId, groupId, week, startDate, endDate, token }) {
  let url = `/schedule/actual?studentId=${studentId}&groupId=${groupId}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  } else if (week !== undefined) {
    url += `&week=${week}`;
  }
  return apiFetch(url, { token });
}

export async function getWeeks() {
  return apiFetch('/schedule/weeks');
} 

export async function getAllSchedulesForWeek({ week, startDate, endDate, token }) {
  let url = `/schedule/all`;
  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`;
  } else if (week !== undefined) {
    url += `?week=${week}`;
  }
  return apiFetch(url, { token });
} 

export async function getStudentPayments({ studentId, token }) {
  return apiFetch(`/students/${studentId}/payments`, { token });
}
export async function updateStudentPayments({ studentId, paymentHistory, token }) {
  return apiFetch(`/students/${studentId}/payments`, {
    method: 'PATCH',
    body: { paymentHistory },
    token,
  });
} 

export async function getAllNews({ groupId, token } = {}) {
  let url = '/news';
  if (groupId) url += `?groupId=${groupId}`;
  return apiFetch(url, { token });
}

// Attendance API
export async function getGroupAttendance({ groupId, startDate, endDate, token }) {
  const url = `/attendance/group?groupId=${groupId}&startDate=${startDate}&endDate=${endDate}`;
  return apiFetch(url, { token });
}
export async function getStudentAttendance({ studentId, startDate, endDate, token }) {
  const url = `/attendance/student?studentId=${studentId}&startDate=${startDate}&endDate=${endDate}`;
  return apiFetch(url, { token });
}
export async function getAttendanceContextBySchedule({ scheduleId, token }) {
  return apiFetch(`/attendance/context/${scheduleId}`, { token });
}
export async function markAttendance({ students, studentId, groupId, date, startTime, endTime, subjectId, status, comment, token }) {
  return apiFetch('/attendance', {
    method: 'POST',
    body: { students, studentId, groupId, date, startTime, endTime, subjectId, status, comment },
    token,
  });
}
export async function updateAttendance({ id, status, comment, token }) {
  return apiFetch(`/attendance/${id}`, {
    method: 'PATCH',
    body: { status, comment },
    token,
  });
}
export async function deleteAttendance({ id, token }) {
  return apiFetch(`/attendance/${id}`, {
    method: 'DELETE',
    token,
  });
}
export async function getAttendanceBySchedule({ scheduleId, slotKey, token }) {
  let url = `/attendance/schedule/${scheduleId}`;
  if (slotKey) url += `?slotKey=${encodeURIComponent(slotKey)}`;
  return apiFetch(url, { token });
}
export async function getNewsById({ id, token }) {
  return apiFetch(`/news/${id}`, { token });
}
export async function createNews({ title, text, groupIds, image, token }) {
  let body, headers = {}, method = 'POST';
  if (image) {
    body = new FormData();
    body.append('title', title);
    body.append('text', text);
    if (groupIds && groupIds.length) groupIds.forEach(id => body.append('groupIds', id));
    body.append('image', image);
    headers = {};
  } else {
    body = JSON.stringify({ title, text, groupIds });
    headers = { 'Content-Type': 'application/json' };
  }
  return fetch(`${getApiBaseUrl()}/news`, {
    method,
    headers: token ? { ...headers, Authorization: `Bearer ${token}` } : headers,
    body,
  }).then(async res => {
    let data;
    try { data = await res.json(); } catch { data = {}; }
    if (!res.ok) throw new Error(data.message || 'Ошибка запроса');
    return data;
  });
}
export async function deleteNews(id, token) {
  return apiFetch(`/news/${id}`, {
    method: 'DELETE',
    token,
  });
}
export async function updateNews({ id, title, text, groupIds, token }) {
  return apiFetch(`/news/${id}`, {
    method: 'PATCH',
    body: { title, text, groupIds },
    token,
  });
} 

export async function deleteStudent(id, token) {
  return apiFetch(`/students/${id}`, {
    method: 'DELETE',
    token,
  });
} 

export async function resetStudentPassword(id, token) {
  return apiFetch(`/students/${id}/reset-password`, {
    method: 'PATCH',
    token,
  });
} 

// Сохранить порядок групп
export async function reorderGroups({ orders, token }) {
  return apiFetch('/groups/reorder/all', {
    method: 'PATCH',
    body: { orders },
    token,
  });
}